module.exports = __webpack_public_path__ + "static/twitter-image-131990237467895d2358b9357804ca6f.png";